import { observable, action, computed } from 'mobx'
import find from 'ramda/src/find'

import { customerioTracker } from 'lib'
import { analyticsTracker } from 'utils'

import UserStore from './UserStore'

class PanelStore {
  @observable
  selectedPanel = false

  @computed get panelOptions() {
    const options = UserStore.get('brands')
    return options?.length ? options : []
  }

  @observable
  isReload = false

  @action setSelectedPanel = brand => {
    this.selectedPanel = brand
    if (this.selectedPanel) this.selectedPanel.panelId = brand?.panels?.[0]?.id || ''
  }

  @action getBrandByPanelId = panelId => find(brand => brand.panels?.[0]?.id === panelId)(this.panelOptions)

  @action trackPin = ({ pinTitle, workspaceId, pinType, pinStatus, location = false, topicTitle = false }) => {
    const workspace = this.getBrandByPanelId(workspaceId)
    const { ADD_TO } = analyticsTracker.eventNames
    const { INSIGHT_SAVED } = customerioTracker.eventNames

    customerioTracker.track(INSIGHT_SAVED, {
      content_added: pinType,
    })

    analyticsTracker.eventTrack(
      ADD_TO,
      {
        'Content added': pinType,
        'Content title': pinTitle,
        'Added to': workspace?.name,
        'Dashboard ID': workspace?.id,
        'Pin Status': pinStatus,
        ...(topicTitle && { 'Topic Title': topicTitle }),
      },
      location && location
    )
  }
}

export default new PanelStore()
